module.exports = __webpack_public_path__ + "media/images/wines/tempranillo-reserva/bottle-dae3052dba02991cd4f8d81e9e3c478b.png";